import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueClipboard from 'vue-clipboard2'
 
Vue.use(VueClipboard)
Vue.config.productionTip = false;

import "./assets/js/vant";

// cookie
import cookie from "js-cookie";
Vue.prototype.$cookie = cookie;

var vue =  new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default vue;